import React from "react";
import "./ButtonLogo.css";
import { Link } from "react-router-dom";
import { isAssistant } from "shared/utils/env.js";

interface ButtonLogoProps {}

const ButtonLogo: React.FC<ButtonLogoProps> = (props) => {
  return (
    <div className="ButtonLogo">
      <Link to="/" aria-label={`MFL ${isAssistant() ? "Assistant" : "Coach"} home`}>
        <div className="position-relative d-inline-block image-wrapper mt-lg-3 ms-3 me-2 me-lg-1 ms-lg-0 mb-lg-3">
          <img
            src={isAssistant() ? "/media/images/coach.png" : "/media/images/assistant.png"}
            alt=""
            className="position-absolute bg-img"
          />

          <img
            src={isAssistant() ? "/media/images/assistant.png" : "/media/images/coach.png"}
            alt={`MFL ${isAssistant() ? "Assistant" : "Coach"}`}
            className="img-fluid main-img"
          />
        </div>
      </Link>
    </div>
  );
};

export default ButtonLogo;
